import React from 'react';
import { Box, Divider, Typography, useTheme } from '@mui/material';
import {
    DocumentCsvIcon,
    DocumentDocIcon,
    DocumentExcelIcon,
    DocumentTextIcon,
    DocumentDataIcon,
    DocumentMiscIcon,
} from '../assets/documentIcons';

import { DataIcon, DocIcon, CodeIcon, BookmarkIcon, NewChatIcon } from '../assets/SvgIcons';
import { Toys } from '@mui/icons-material';
import UserGeneratedCodeMessage from './UserGeneratedCodeMessage';

const UserGeneratedMessageWithContext = ({ context, text, iconType }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const backgroundGradient = isDark
        ? 'linear-gradient(to top, rgb(73, 71, 75), rgb(48, 45, 51))'
        : 'linear-gradient(to top, rgba(255, 255, 255, 0.8), rgba(0, 116, 211, 0.1))';

    const backgroundContainer = isDark
        ? 'linear-gradient(to top, rgb(49, 48, 51), rgb(48, 45, 51))'
        : 'linear-gradient(to top, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.1))';

    const borderColor = isDark ? '#555' : '#ddd';
    const dottedLineColor = isDark ? '#aaa' : '#000';
    const textColor = isDark ? 'rgb(119, 116, 122)' : 'rgb(72, 69, 75)';

    const renderProptType = (type) => {
        switch (type) {
            case 'analyze_document':
                return <DocIcon width={31} height={31} />;
            case 'analyze_dataset':
                return <DataIcon width={31} height={31} />;
            case 'code_assistant':
                return <CodeIcon width={31} height={31} />;
            case 'manage_saved_prompts':
                return <BookmarkIcon width={31} height={31} />;
            default:
                return null;
        }
    };

    const renderPromptContext = (item) => {
        console.log(item);
        switch (item.type) {
            case 'analyze_document':
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: 2 }}>
                            <Box sx={{ width: '30px', height: '30px' }}>
                                {renderProptType(item.type)}
                            </Box>
                            <Typography
                                sx={{
                                    ml: 2,
                                    fontWeight: 'bold',
                                    color: textColor,
                                }}
                            >
                                Analyze Document
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                mt: 2,
                                mr: 2,
                                ml: 2,
                                pt: 2,
                                pb: 2,
                                pl: 2,
                                borderRadius: 1,
                                boxShadow: 1,
                                background: backgroundContainer

                            }}
                        >
                            <Typography
                                sx={{
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                }}
                            >
                                {item.document.fileName || 'Document'}
                            </Typography>
                        </Box>
                    </Box>
                );
            case 'analyze_dataset':
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: 2 }}>
                            <Box sx={{ width: '30px', height: '30px' }}>
                                {renderProptType(item.type)}
                            </Box>
                            <Typography
                                sx={{
                                    ml: 2,
                                    fontWeight: 'bold',
                                    color: textColor,
                                }}
                            >
                                Analyze Dataset
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                mt: 2,
                                mr: 2,
                                ml: 2,
                                pt: 2,
                                pb: 2,
                                pl: 2,
                                borderRadius: 1,
                                boxShadow: 1,
                                background: backgroundContainer

                            }}
                        >
                            <Typography>
                                {item.config.dataSetName || 'Dataset'}
                            </Typography>
                        </Box>
                    </Box>
                );
            case 'code_assistant':
                return (
                    <Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: 2 }}>
                            <Box sx={{ width: '30px', height: '30px' }}>
                                {renderProptType(item.type)}
                            </Box>
                            <Typography
                                sx={{
                                    ml: 2,
                                    fontWeight: 'bold',
                                    color: textColor,
                                }}
                            >
                                Analyze Code
                            </Typography>
                        </Box>
                        <Box sx={{ ml: 2, mr: 2, mb: 1 }}>
                            <UserGeneratedCodeMessage text={item.code} />
                        </Box>
                    </Box>
                );
            case 'manage_saved_prompts':
                return (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: 2 }}>
                            <Box sx={{ width: '30px', height: '30px' }}>
                                {renderProptType(item.type)}
                            </Box>
                            <Typography
                                sx={{
                                    ml: 2,
                                    fontWeight: 'bold',
                                    color: textColor,
                                }}
                            >
                                Saved Prompt
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                mt: 2,
                                mr: 2,
                                ml: 2,
                                pt: 2,
                                pb: 2,
                                pl: 2,
                                borderRadius: 1,
                                boxShadow: 1,
                                background: backgroundContainer

                            }}
                        >
                            <Typography>
                                {item.description || 'Document'}
                            </Typography>
                        </Box>
                    </Box>
                );
            default:
                return (
                    <Typography sx={{ ml: 3 }}>
                        type our some random text here that is long enough to wrap to the
                        next line and see how it looks
                    </Typography>
                );
        }
    };

    const renderIcon = (fileType) => {
        switch (fileType) {
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return <DocumentExcelIcon width={76} height={76} />;
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return <DocumentDocIcon width={76} height={76} />;
            case 'text/csv':
                return <DocumentCsvIcon width={76} height={76} />;
            case 'text/plain':
                return <DocumentTextIcon width={76} height={76} />;
            case 'application/json':
                return <DocumentDataIcon width={76} height={76} />;
            default:
                return null;
        }
    };

    const renderPromptItems = () => {
        return (
            <Box
            // sx={{
            //     display: 'flex',
            //     flexDirection: 'column',
            //     alignItems: 'left',
            //     justifyContent: 'left',
            // }}
            >
                {context.promptItems.map((item, index) => (
                    <>
                        {index < context.promptItems.length - 1 && (
                            <Box
                                sx={{
                                    mt: 1,
                                    mb: 3,
                                }}
                            >
                                {/* <Divider>{`SETP ${index + 1}`}</Divider> */}
                            </Box>
                        )}
                        <Box
                            key={index}
                            sx={{
                                //display: 'flex',
                                //alignItems: 'center',
                                //justifyContent: 'left',
                                width: '100%',
                            }}
                        >


                            {renderPromptContext(item)}

                            {/* <Box sx={{ mt: 1.5, ml: -2 }}>{renderIcon(item.document?.fileType || 'application/json')}</Box> */}
                        </Box>

                        {index < context.promptItems.length - 1 && (
                            <Box
                                sx={{
                                    mt: 3,
                                    mb: 3,
                                }}
                            >
                                {/* <Divider>{`SETP ${index + 2}`}</Divider> */}
                            </Box>
                        )}
                    </>
                ))}
            </Box>
        );
    };

    return (
        <Box
            sx={{
                p: 2,
                mt: 1,
                mb: 1,
                minHeight: 100,
                borderRadius: 1,
                boxShadow: 1,
                background: backgroundGradient,
            }}
        >
            <Box
                sx={
                    {
                        // display: 'flex',
                        // flexDirection: 'row',
                        // alignItems: 'center',
                        //justifyContent: 'center',
                    }
                }
            >
                {context.promptItems && renderPromptItems()}
            </Box>

            {text && text.length > 0 && context.promptItems.length > 0 && (
                <Box
                    sx={{
                        mt: 3,
                        mb: 3,
                    }}
                >
                    {/* <Divider>{`SETP ${context.promptItems.length + 1}`}</Divider> */}
                </Box>
            )}
            {text && text.length > 0 && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        //alignItems: 'center',
                        //justifyContent: 'center',
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', ml: 2 }}>
                            <Box sx={{ width: '30px', height: '30px' }}>
                                <NewChatIcon width={31} height={31} />
                            </Box>
                            <Typography sx={{ ml: 2, fontWeight: 'bold', color: textColor }}>
                                Custom Prompt
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                mt: 2,
                                mr: 2,
                                ml: 2,
                                pt: 2,
                                pb: 2,
                                pl: 2,
                                borderRadius: 1,
                                boxShadow: 1,
                                background: backgroundContainer

                            }}
                        >
                            <Typography>
                                {text && text.length > 0 ? text : 'No text provided'}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )}

        </Box>
    );
};

export default UserGeneratedMessageWithContext;
